enum Measure {
  None = 0,
  M10 = 0x1,
  M11 = 0x2,
  M14 = 0x4,
  MLADI = 0x8,
  INTERVENCIJA_7801 = 0x10,
  INTERVENCIJA_7802 = 0x20
}

export const MeasureFilterFields: Record<string, { value: number; label: string }> = {
    M10: { value: Measure.M10, label: "M10" },
    M11: { value: Measure.M11, label: "M11" },
    M14: { value: Measure.M14, label: "M14" },
    MLADI: { value: Measure.MLADI, label: "MLADI" },
    INTERVENCIJA_7801: { value: Measure.INTERVENCIJA_7801, label: "Intervencija 78.01" },
    INTERVENCIJA_7802: { value: Measure.INTERVENCIJA_7802, label: "Intervencija 78.02" },
};